export enum ActiveOrInactive {
    active = 'active',
    inactive = 'inactive',
}
